// Server Model
export interface SystemSettingsDataModel {
    Tag: string;
    TagOnScreen: string;
    Value: string;
}

// React model
export class SystemSettingsModel {
    public settings: Record<string, Setting> = {};
}

export class Setting {
    tag = '';
    tagOnScreen = '';
    value = '';

    constructor(tag: string, tagOnScreen: string, value: string) {
        this.tag = tag;
        this.tagOnScreen = tagOnScreen;
        this.value = value;
    }
}

export function systemSettingsMapper(model: SystemSettingsDataModel[]): SystemSettingsModel | null {
    if (model == null) {
        return null;
    }

    const settings: Record<string, Setting> = {};

    model.forEach((x) => {
        settings[x.Tag] = new Setting(x.Tag, x.TagOnScreen, x.Value);
    });

    return {
        settings,
    };
}
